import _toConsumableArray from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.flat-map.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { toast } from '@/utils/message';
import request from '@/utils/request';

import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XUpload',
  props: {
    action: {
      type: String,
      required: true
    },
    value: Object,
    callback: Function,
    upload: Function,
    accept: String,
    multiple: {
      type: Boolean,
      default: false
    },
    autoUpload: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    limit: Number,
    maxSize: {
      type: Number,
      default: 1024 * 1024 * 100
    },
    timeout: {
      type: Number,
      default: 6 * 60 * 1000
    },
    onExceed: Function,
    onChange: Function,
    onRemove: Function,
    onSuccess: Function,
    onError: Function,
    onModified: Function,
    beforeUpload: Function
  },
  setup: function setup(__props, _ref) {
    var _props$callback, _props$onSuccess, _props$onError, _props$onModified, _props$onExceed;
    var __expose = _ref.expose;
    /**
     * 上传组件
     * 封装自el-upload
     * 实现了多文件同时上传的功能
     *
     * @author Jay Qing
     */
    var props = __props;
    var callbackFn = (_props$callback = props.callback) !== null && _props$callback !== void 0 ? _props$callback : defaultCallback;
    var onSuccessFn = (_props$onSuccess = props.onSuccess) !== null && _props$onSuccess !== void 0 ? _props$onSuccess : defaultSuccess;
    var onErrorFn = (_props$onError = props.onError) !== null && _props$onError !== void 0 ? _props$onError : defaultError;
    var onModifiedFn = (_props$onModified = props.onModified) !== null && _props$onModified !== void 0 ? _props$onModified : defaultModified;
    var uploadFileList = ref(_toConsumableArray(props.fileList));
    var onExceedFn = ref((_props$onExceed = props.onExceed) !== null && _props$onExceed !== void 0 ? _props$onExceed : defaultExceed);
    var uploader = ref();
    function doUpload() {
      var files = uploadFileList.value;
      var data = props.value;
      if (!files || files.length < 1) {
        return false;
      }
      if (props.beforeUpload && !props.beforeUpload(files, data)) {
        return;
      }
      console.log(3);
      Promise.all(files.flatMap(function (file) {
        return checkModification(file);
      })).then(function () {
        console.log(2);
        performUpload(files, data);
      }).catch(function (file) {
        console.log(1);
        onModifiedFn(file, files);
      });
      return false;
    }
    /**
     * 检查文件是否已发生改变
     *
     * @param file 文件
     */
    function checkModification(file) {
      var _file$raw;
      return (_file$raw = file.raw) === null || _file$raw === void 0 ? void 0 : _file$raw.slice(0, 1).arrayBuffer().catch(function () {
        return Promise.reject(file);
      });
    }
    function performUpload(files, data) {
      console.log(files);
      var form = new FormData();
      files.forEach(function (file) {
        form.append('file', file.raw);
      });
      if (data) {
        Object.keys(data).forEach(function (key) {
          return form.append(key, data[key]);
        });
      }
      if (props.action) {
        var result = request({
          url: props.action,
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          method: 'post',
          data: form,
          timeout: props.timeout
        }, {
          showErrorMessage: false
        });
        if (callbackFn) {
          callbackFn(result);
        }
      } else if (props.upload) {
        props.upload(form);
      }
    }
    function change(uploadFile, uploadFiles) {
      uploadFileList.value = uploadFiles.filter(function (item) {
        return item.status === 'ready';
      });
      if (props.onChange) {
        props.onChange(uploadFile, uploadFiles);
      }
    }
    function remove(uploadFile, uploadFiles) {
      uploadFileList.value = uploadFiles.filter(function (item) {
        return item.status === 'ready';
      });
      if (props.onRemove) {
        props.onRemove(uploadFile, uploadFiles);
      }
    }
    function defaultModified(file) {
      toast.warn("\u6587\u4EF6 ".concat(file.name, " \u5DF2\u4FEE\u6539\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u6B64\u6587\u4EF6"));
    }
    function defaultSuccess() {
      toast.success("\u4E0A\u4F20\u6210\u529F");
    }
    function defaultError() {
      toast.error('上传出错');
    }
    function defaultExceed() {
      toast.warn("\u6700\u591A\u53EA\u80FD\u9009\u62E9".concat(props.limit, "\u4E2A\u6587\u4EF6"));
    }
    function defaultCallback(promise) {
      promise.then(function (result) {
        onSuccessFn(result, props.fileList);
      }).catch(function (error) {
        onErrorFn(error, props.fileList);
      });
    }
    function submit() {
      doUpload();
    }
    function clearFiles() {
      var _uploader$value;
      (_uploader$value = uploader.value) === null || _uploader$value === void 0 || _uploader$value.clearFiles();
    }
    __expose({
      submit: submit,
      clearFiles: clearFiles
    });
    return function (_ctx, _cache) {
      var _component_el_upload = _resolveComponent("el-upload");
      return _openBlock(), _createBlock(_component_el_upload, {
        ref_key: "uploader",
        ref: uploader,
        accept: __props.accept,
        data: __props.value,
        "auto-upload": false,
        "file-list": __props.fileList,
        disabled: __props.disabled,
        multiple: __props.multiple,
        limit: __props.limit,
        "on-exceed": _unref(onExceedFn),
        "on-change": change,
        "on-remove": remove,
        drag: ""
      }, _createSlots({
        default: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "default")];
        }),
        _: 2
      }, [_ctx.$slots.trigger ? {
        name: "trigger",
        fn: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "trigger")];
        }),
        key: "0"
      } : undefined, _ctx.$slots.tip ? {
        name: "tip",
        fn: _withCtx(function () {
          return [_renderSlot(_ctx.$slots, "tip")];
        }),
        key: "1"
      } : undefined]), 1032, ["accept", "data", "file-list", "disabled", "multiple", "limit", "on-exceed"]);
    };
  }
});